import { render, staticRenderFns } from "./LabelOptions.vue?vue&type=template&id=0eb0a6ab"
import script from "./LabelOptions.vue?vue&type=script&lang=ts"
export * from "./LabelOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports